import { render, staticRenderFns } from "./cModalIncome.vue?vue&type=template&id=6db33c1c&scoped=true"
import script from "./cModalIncome.vue?vue&type=script&lang=js"
export * from "./cModalIncome.vue?vue&type=script&lang=js"
import style0 from "./cModalIncome.vue?vue&type=style&index=0&id=6db33c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db33c1c",
  null
  
)

export default component.exports